module.exports = __webpack_public_path__ + "media/body-condition/puppy-just-right-0654fe56.svg";